import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import CrossWalkTable from './cross-walk-table/cross-walk-table';
import CrossWalkPopup from './cross-walk-popup/cross-walk-popup';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

@Component({
    name: 'cross-walk',
    components: {
        'material-icon': GoogleMaterialIcon,
        'crosswalk-table': CrossWalkTable,
        'crosswalk-popup': CrossWalkPopup,
        'scale-loader': ScaleLoader,
    },
})

export default class CrossWalk extends Vue {

    // -----------------------------------------------------------------------------
    // Properties

    private tableData: any = {};

    private isShowPopup: boolean = false;

    private isScrollTop: boolean = false;

    private isLoading: boolean = false;


    // ----------------------------------------------------------------------------
    // Actions
    private onGenerateTable(tableData: any) {
        this.isScrollTop = true;
        this.isShowPopup = true;
        this.tableData = tableData;
        this.isLoading  = false;
    }

    private scrollTop() {
        this.isScrollTop = false;
        document.body.scrollIntoView({behavior: 'smooth'});
    }
}
